import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageManagementModel } from '@ay-gosu/server-shared';
import { LegacyAppearanceDirective } from '../../../material/legacy/mat-form-field/legacy-appearance.directive';
import { MessageManagementService } from '../../../service/message-management.service';

@Component({
  selector: 'mm-create-folder',
  templateUrl: './create-folder.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatButton,
    LegacyAppearanceDirective,
  ],
  host: {
    class: 'flex flex-col gap-4',
  },
})
export class CreateFolderComponent {
  public constructor(
    private readonly _matSnackBar: MatSnackBar,
    private readonly _matDialogRef: MatDialogRef<any>,
    private readonly _messageManagementService: MessageManagementService,
  ) {}

  public name = new FormControl('', Validators.required);

  public formGroup = new FormGroup({
    name: this.name,
  });

  public async submit() {
    this.formGroup.markAsDirty();
    if (this.formGroup.invalid) {
      return;
    }

    const folderId = await MessageManagementModel.createFolder({
      name: this.formGroup.value.name,
    });
    this._messageManagementService.folderList$.reload();
    this._matSnackBar.open($localize`成功建立訊息資料夾`);
    this._matDialogRef.close(folderId);
  }

  public cancel() {
    this._matDialogRef.close();
  }
}
